import ExecutionContext from '~/Features/ExecutionContext';
import type { ApplicationChoiceDto } from '~/Features/Search/ApplicationChoice/Controller/ApplicationChoiceDto.csharp';

export const CampusApplicationStateStorageKey = 'campusApplicationState';
export const MaxChoicesNumber = 3;

export const getStoredCampusApplicationChoices = (): ApplicationChoiceDto[] => {
    if (ExecutionContext.IsServerSide()) {
        return [];
    }

    const currentStateJson = localStorage.getItem(CampusApplicationStateStorageKey);

    if (currentStateJson) {
        return JSON.parse(currentStateJson);
    }

    return [];
};
